import { Modal, ModalCloseButton } from "../../components/ui";
import AgentLaunchPage from "../pages/AgentLaunchPage";

export default function DraftRunEditorModal({
  draftId,
  onClose,
}: {
  draftId: string;
  onClose: () => void;
}) {
  return (
    <Modal
      size="large"
      className="agent-launch-modal"
      ariaLabel="Edit draft run"
      onClose={onClose}
    >
      <ModalCloseButton floating onClick={onClose} />
      <AgentLaunchPage modal draftId={draftId} onClose={onClose} />
    </Modal>
  );
}
